export class UserContext {
    person_id: number;
    student_id: number;
}